/**
 * Full-page navigation away from the app.
 *
 * These are the cases where React Router is not involved at all: handing the browser to the
 * server's OAuth endpoints, to Stripe, or back to a URL the server handed us. They are written
 * as functions rather than inline `window.location.href = …` so there is a module boundary a
 * test can mock.
 *
 * That boundary became necessary with jsdom 26 (Jest 30): `window.location` is now a
 * non-configurable property, so the long-standing test trick of `delete window.location` and
 * assigning a stub no longer works — `delete` returns false, and `Object.defineProperty` on
 * either `window.location` or `location.href` throws "Cannot redefine property".
 */

/**
 * Navigate the browser to a URL, leaving the single-page app.
 *
 * @param {string} url absolute or app-relative URL
 */
export const navigateTo = url => {
  window.location.href = url;
};

/**
 * Navigate without leaving an entry in the session history.
 *
 * @param {string} url absolute or app-relative URL
 */
export const replaceLocation = url => {
  window.location.replace(url);
};
